const data = {
  greeting_checking: `Hello, {username}! GINA is checking the machine record...`,
  checking: `GINA is checking the machine record...`,
  greeting_all_clear: `Hello, {username}! your machinery are on healthy condition. Great Job!`,
  have_outstanding: `Hello, {username}! You have {qty} outstanding alerts for {sublocation} {machine}! \nClick {click} for the details of the alerts`,
  have_outstanding_left: `You have attended {qty_done} alert for for {sublocation} {machine}, There are {qty} alerts Left! \nClick {click} for the details of the alerts`,
  knowledge_inputed: `Thank you, {username}! You have just made GINA smarter!,\n Let me check if there's any other Alert that require your attention..`,
  all_clear: `Wow, your machinery are on healthy condition. Great Job! `,
  alert_detail: `Based on the Meta Asset Capsule™, I suspect there is an intake obstruction in {machine}, and this is a {severity} Alert, Look into this as priority!`,
  under_construction: `This page is still under construction, and will be available soon! `,
  help_in_knowledge: `You can help improve GINA in anomaly detection by submitting knowledge input 😁 `,
};
export default data;
